/* SAZUKO — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  // Varias secciones cargan este archivo: solo debe ejecutarse una vez
  if (window.__szScripts) return;
  window.__szScripts = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesk = function () { return window.matchMedia('(min-width: 990px)').matches; };

  /* ---- Scroll: un solo bucle rAF para todo lo que depende del scroll ---- */
  var scrollFns = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      for (var i = 0; i < scrollFns.length; i++) scrollFns[i]();
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---- Fecha de entrega: "[fecha]" = hoy + N días (ficha del producto y carrito) ---- */
  function fillEntrega(root) {
    (root || document).querySelectorAll('[data-sz-entrega]:not([data-sz-ok])').forEach(function (el) {
      var dias = parseInt(el.getAttribute('data-sz-entrega'), 10);
      var txt = el.getAttribute('data-texto') || '';
      if (!dias || txt.indexOf('[fecha]') === -1) return;
      var d = new Date();
      d.setDate(d.getDate() + dias);
      try {
        var f = d.toLocaleDateString('es-ES', { weekday: 'long' }) + ' ' + d.getDate() + ' de ' + d.toLocaleDateString('es-ES', { month: 'long' });
        el.setAttribute('data-sz-ok', '1');
        el.textContent = txt.replace('[fecha]', f);
      } catch (e) {}
    });
  }
  /* El carrito lateral se vuelve a pintar al añadir o quitar productos: rellena la fecha cada vez */
  function watchCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__szWatch || !window.MutationObserver) return;
    drawer.__szWatch = true;
    new MutationObserver(function () { fillEntrega(drawer); }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---- Reveals ---- */
  var io = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.sz-reveal, .sz-mask, .sz-img-reveal, [data-sz-in]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---- Parallax suave (hero, cierre) ---- */
  function initParallax() {
    var items = document.querySelectorAll('[data-sz-parallax]');
    if (!items.length || reduce) return;
    scrollFns.push(function () {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-sz-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(2) + 'px,0)';
      });
    });
  }

  /* ---- Contadores ---- */
  function initCounters() {
    var els = document.querySelectorAll('[data-sz-count]');
    if (!els.length) return;
    var run = function (el) {
      var raw = el.getAttribute('data-sz-count');
      var m = raw.match(/[\d.,]+/);
      if (!m || reduce) return;
      var target = parseFloat(m[0].replace(',', '.'));
      var dec = (m[0].split(/[.,]/)[1] || '').length;
      var sep = m[0].indexOf(',') > -1 ? ',' : '.';
      var t0 = null;
      var step = function (t) {
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / 1400, 1);
        k = 1 - Math.pow(1 - k, 4);
        el.textContent = raw.replace(m[0], (target * k).toFixed(dec).replace('.', sep));
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    var o = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { run(e.target); o.unobserve(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { o.observe(el); });
  }

  /* ---- Botones magnéticos ---- */
  function initMagnetic() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.sz-btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.28;
        b.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---- Selector de estilos (auto-rotación con barra de progreso) ---- */
  function initEstilos() {
    document.querySelectorAll('[data-sz-estilos]').forEach(function (root) {
      var items = root.querySelectorAll('.sz-estilo');
      var imgs = root.querySelectorAll('.sz-estilos__img');
      var cur = root.querySelector('[data-sz-cur]');
      var auto = parseInt(root.getAttribute('data-auto'), 10) || 0;
      var idx = 0, timer = null;
      if (!items.length) return;
      function go(i) {
        idx = (i + items.length) % items.length;
        items.forEach(function (el, k) {
          el.classList.toggle('is-active', k === idx);
          var bar = el.querySelector('.sz-estilo__bar');
          if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        imgs.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
        if (cur) cur.textContent = String(idx + 1).padStart(2, '0');
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (auto && !reduce && isDesk() && root.getAttribute('data-paused') !== 'true') timer = setTimeout(function () { go(idx + 1); }, auto * 1000);
      }
      items.forEach(function (el, k) {
        var btn = el.querySelector('.sz-estilo__btn');
        btn.addEventListener('click', function () {
          go(k);
          if (!isDesk()) setTimeout(function () {
            var top = el.getBoundingClientRect().top;
            if (top < 70 || top > window.innerHeight * 0.45) window.scrollTo({ top: window.scrollY + top - 90, behavior: reduce ? 'auto' : 'smooth' });
          }, 720);
        });
        btn.addEventListener('mouseenter', function () { if (isDesk()) go(k); });
      });
      root.addEventListener('mouseenter', function () { root.setAttribute('data-paused', 'true'); clearTimeout(timer); });
      root.addEventListener('mouseleave', function () { root.setAttribute('data-paused', 'false'); schedule(); });
      var o = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) schedule(); else clearTimeout(timer);
      });
      o.observe(root);
      go(0);
    });
  }

  /* ---- Pasos: escena sticky ---- */
  function initPasos() {
    document.querySelectorAll('[data-sz-pasos]').forEach(function (root) {
      var steps = root.querySelectorAll('.sz-paso');
      var figs = root.querySelectorAll('.sz-pasos__stack figure');
      var rail = root.querySelector('.sz-pasos__rail span');
      var badge = root.querySelector('[data-sz-badge]');
      scrollFns.push(function () {
        if (!isDesk()) return;
        var mid = window.innerHeight * 0.55;
        var active = 0;
        steps.forEach(function (s, i) { if (s.getBoundingClientRect().top < mid) active = i; });
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === active); });
        figs.forEach(function (f, i) { f.classList.toggle('is-shown', i <= active); });
        if (badge) badge.textContent = String(active + 1).padStart(2, '0');
        if (rail) {
          var r = root.querySelector('.sz-pasos__steps').getBoundingClientRect();
          var p = Math.min(Math.max((mid - r.top) / r.height, 0), 1);
          rail.parentElement.style.setProperty('--p', p.toFixed(3));
          rail.style.transform = 'scaleY(' + p.toFixed(3) + ')';
        }
      });
    });
  }

  /* ---- Usos: galería horizontal guiada por el scroll vertical ---- */
  function initUsos() {
    document.querySelectorAll('[data-sz-usos]').forEach(function (root) {
      var track = root.querySelector('.sz-usos__track');
      var prog = root.querySelector('.sz-usos__progress span');
      var cards = root.querySelectorAll('.sz-uso');
      var dist = 0;
      function measure() {
        if (!isDesk()) { root.style.height = ''; return; }
        dist = Math.max(track.scrollWidth - window.innerWidth, 0);
        root.style.height = (window.innerHeight + dist) + 'px';
      }
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      scrollFns.push(function () {
        if (!isDesk()) return;
        var r = root.getBoundingClientRect();
        var p = Math.min(Math.max(-r.top / Math.max(dist, 1), 0), 1);
        track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px,0,0)';
        if (prog) prog.style.transform = 'scaleX(' + p.toFixed(3) + ')';
        if (!reduce) cards.forEach(function (c) {
          var cr = c.getBoundingClientRect();
          var k = (cr.left + cr.width / 2 - window.innerWidth / 2) / window.innerWidth;
          var img = c.querySelector('img');
          if (img) img.style.setProperty('--px', (k * -40).toFixed(1) + 'px');
        });
      });
    });
  }

  /* ---- Detalles: puntos interactivos sincronizados con la lista ---- */
  function initDetalles() {
    document.querySelectorAll('[data-sz-det]').forEach(function (root) {
      var pins = root.querySelectorAll('.sz-pin');
      var items = root.querySelectorAll('.sz-det__item');
      var timer = null, idx = 0, touched = false;
      var nowN = root.querySelector('[data-sz-now-n]'), nowT = root.querySelector('[data-sz-now-t]'), nowP = root.querySelector('[data-sz-now-p]');
      function set(i) {
        idx = i;
        pins.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        items.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        var it = items[i];
        if (it && nowT) {
          nowN.textContent = i + 1;
          nowT.textContent = it.querySelector('h3').textContent;
          nowP.innerHTML = it.querySelector('p').innerHTML;
        }
      }
      function cycle() { clearInterval(timer); if (!reduce && !touched) timer = setInterval(function () { set((idx + 1) % pins.length); }, 3200); }
      function bind(list) {
        list.forEach(function (el, k) {
          el.addEventListener('mouseenter', function () { clearInterval(timer); set(k); });
          el.addEventListener('click', function () { if (!isDesk()) touched = true; clearInterval(timer); set(k); });
          el.addEventListener('mouseleave', cycle);
        });
      }
      bind(pins); bind(items);
      if (pins.length) { set(0); cycle(); }
    });
  }

  /* ---- FAQ: apertura animada de <details> ---- */
  function initFaq() {
    document.querySelectorAll('.sz-q').forEach(function (d) {
      var sum = d.querySelector('summary');
      var body = d.querySelector('.sz-q__a');
      if (!sum || !body) return;
      sum.addEventListener('click', function (e) {
        if (reduce) return;
        e.preventDefault();
        var group = d.closest('[data-sz-single]');
        if (!d.open) {
          if (group) group.querySelectorAll('.sz-q[open]').forEach(function (o) { if (o !== d) close(o); });
          d.open = true;
          var h = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
        } else close(d);
      });
      function close(el) {
        var b = el.querySelector('.sz-q__a');
        var a = b.animate([{ height: b.scrollHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' });
        a.onfinish = function () { el.open = false; };
      }
    });
  }

  /* ---- Producto: galería + variantes + cantidad + barra fija ---- */
  function initProducto() {
    document.querySelectorAll('[data-sz-prod]').forEach(function (root) {
      var slides = root.querySelectorAll('.sz-prod__slide');
      var thumbs = root.querySelectorAll('.sz-prod__thumb');
      var cur = 0;
      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        var t = thumbs[cur];
        if (t && t.parentElement) {
          var p = t.parentElement;
          if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: t.offsetTop - p.clientHeight / 2, behavior: 'smooth' });
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = root.querySelector('[data-sz-prev]'), next = root.querySelector('[data-sz-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      var main = root.querySelector('.sz-prod__main');
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      var dataEl = root.querySelector('[data-sz-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelectorAll('[data-sz-price]');
      var compareEl = root.querySelector('[data-sz-compare]');
      var badgeEl = root.querySelector('[data-sz-badge-off]');
      var btns = root.querySelectorAll('[data-sz-add]');
      var btnText = root.querySelectorAll('[data-sz-add-text]');
      var fmt = function (cents) {
        var cfg = root.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace('.', ',');
        return cfg.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount\s*\}\}/, v);
      };
      function selected() {
        var vals = [];
        root.querySelectorAll('.sz-opt').forEach(function (fs) {
          var a = fs.querySelector('.sz-opt__val.is-active');
          vals.push(a ? a.getAttribute('data-value') : null);
        });
        return vals;
      }
      function update() {
        var vals = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceEl.forEach(function (p) { p.textContent = fmt(v.price); });
        if (compareEl) {
          var has = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.textContent = has ? fmt(v.compare_at_price) : '';
          compareEl.hidden = !has;
          if (badgeEl) {
            badgeEl.hidden = !has;
            if (has) badgeEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        btns.forEach(function (b) {
          if (v.available) { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); } else { b.setAttribute('disabled', ''); }
        });
        btnText.forEach(function (t) { t.textContent = v.available ? t.getAttribute('data-on') : t.getAttribute('data-off'); });
        root.querySelectorAll('.sz-opt').forEach(function (fs, i) {
          var lab = fs.querySelector('[data-sz-optlabel]');
          if (lab) lab.textContent = vals[i];
        });
        curV = v;
        renderPack();
        syncPreview();
        if (v.media_index !== null && v.media_index !== undefined) show(v.media_index);
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      }
      root.querySelectorAll('.sz-opt__val').forEach(function (b) {
        b.addEventListener('click', function () {
          b.parentElement.querySelectorAll('.sz-opt__val').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          update();
        });
      });

      /* Packs: 1, 2 o 3 unidades; en los packs cada unidad puede ser de un estilo */
      var packs = root.querySelector('[data-sz-packs]');
      var packN = packs ? (parseInt(packs.getAttribute('data-def'), 10) || 1) : 1;
      var totalEl = root.querySelectorAll('[data-sz-total]');
      function packDesc(n) {
        if (!packs || n < 2) return 0;
        return parseInt(packs.getAttribute('data-d' + n), 10) || 0;
      }
      function renderPack() {
        var unit = curV ? curV.price : 0;
        if (packs) {
          packs.querySelectorAll('.sz-pack__o').forEach(function (o) {
            var n = parseInt(o.getAttribute('data-n'), 10);
            var pp = o.querySelector('[data-sz-pack-price]');
            var pb = o.querySelector('[data-sz-pack-bruto]');
            if (pp) pp.textContent = fmt(unit * n - packDesc(n));
            if (pb) pb.textContent = fmt(unit * n);
          });
          var extra = packs.querySelector('[data-sz-pack-extra]');
          if (extra) extra.hidden = packN < 2;
          packs.querySelectorAll('[data-sz-pack-row]').forEach(function (r) {
            r.hidden = parseInt(r.getAttribute('data-sz-pack-row'), 10) > packN;
          });
        }
        totalEl.forEach(function (t) { t.textContent = fmt(unit * packN - packDesc(packN)); });
      }
      if (packs) {
        packs.querySelectorAll('.sz-pack__o').forEach(function (o) {
          o.addEventListener('click', function () {
            packN = parseInt(o.getAttribute('data-n'), 10);
            packs.querySelectorAll('.sz-pack__o').forEach(function (x) {
              var on = x === o;
              x.classList.toggle('is-active', on);
              x.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            renderPack();
          });
        });
        packs.querySelectorAll('[data-sz-pack-row]').forEach(function (r) {
          r.querySelectorAll('.sz-pack__sw').forEach(function (b) {
            b.addEventListener('click', function () {
              r.querySelectorAll('.sz-pack__sw').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
              b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
              var nm = r.querySelector('[data-sz-pack-name]');
              if (nm) nm.textContent = b.getAttribute('data-name');
            });
          });
        });
        var pf = root.querySelector('product-form');
        if (pf) pf.addEventListener('submit', function (e) {
          if (packN < 2) return;
          e.preventDefault();
          e.stopPropagation();
          var btn = pf.querySelector('[type="submit"]');
          if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
          var ids = [idInput.value];
          packs.querySelectorAll('[data-sz-pack-row]').forEach(function (r) {
            if (parseInt(r.getAttribute('data-sz-pack-row'), 10) > packN) return;
            var a = r.querySelector('.sz-pack__sw.is-active');
            ids.push(a ? a.getAttribute('data-id') : idInput.value);
          });
          var count = {};
          ids.forEach(function (id) { count[id] = (count[id] || 0) + 1; });
          var items = Object.keys(count).map(function (id) { return { id: parseInt(id, 10), quantity: count[id] }; });
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var body = { items: items };
          if (cart && cart.getSectionsToRender) {
            body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
            body.sections_url = window.location.pathname;
          }
          var spin = pf.querySelector('.loading__spinner');
          var errW = pf.querySelector('.product-form__error-message-wrapper');
          var errM = pf.querySelector('.product-form__error-message');
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('loading');
          if (spin) spin.classList.remove('hidden');
          if (errW) errW.hidden = true;
          var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
          fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (errW && errM) { errM.textContent = res.description || res.message || 'Error'; errW.hidden = false; }
                return;
              }
              if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
              if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sz-pack', cartData: res });
              cart.classList.remove('is-empty');
              cart.renderContents(res);
            })
            .catch(function (err) { console.error(err); })
            .finally(function () {
              btn.classList.remove('loading');
              btn.removeAttribute('aria-disabled');
              if (spin) spin.classList.add('hidden');
            });
        }, true);
      }
      fillEntrega(root);

      /* Móvil: foto del diseño elegido junto al selector */
      var preview = root.querySelector('[data-sz-opt-preview]');
      // Al entrar se ve la modelo con la bandolera puesta; al elegir diseño, la foto del diseño.
      // Si se llega con un diseño concreto en el enlace (?variant=), se muestra ese diseño.
      var verModelo = !!(preview && preview.querySelector('[data-modelo]')) && !/[?&]variant=/.test(window.location.search);
      root.querySelectorAll('.sz-opt__val').forEach(function (b) {
        b.addEventListener('click', function () { verModelo = false; }, true);
      });
      function syncPreview() {
        if (!preview || !curV) return;
        var imgs = preview.querySelectorAll('img');
        var hit = false;
        imgs.forEach(function (im) {
          var on = verModelo ? im.hasAttribute('data-modelo') : String(im.getAttribute('data-vid')) === String(curV.id);
          if (on) { hit = true; im.loading = 'eager'; }
          im.classList.toggle('is-on', on);
        });
        preview.hidden = !hit;
      }

      var curV = variants.find(function (x) { return idInput && String(x.id) === String(idInput.value); }) || variants[0];
      renderPack();
      syncPreview();

      var qty = root.querySelector('.sz-qty input');
      root.querySelectorAll('[data-sz-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, n + parseInt(b.getAttribute('data-sz-qty'), 10));
        });
      });

      var sticky = root.querySelector('.sz-sticky-buy');
      var mainBtn = root.querySelector('.sz-buy');
      if (sticky && mainBtn) {
        // Visible cuando el botón principal no está en pantalla, pasada la galería
        // (en móvil el botón queda lejos; así siempre hay un botón de compra a mano)
        var btnVisible = true;
        var gal = root.querySelector('.sz-prod__gallery');
        var so = new IntersectionObserver(function (en) { btnVisible = en[0].isIntersecting; syncSticky(); });
        so.observe(mainBtn);
        var syncSticky = function () {
          // Si la galería está oculta (móvil), se usa la foto del selector como referencia
          var ref = (gal && gal.offsetParent) ? gal : (root.querySelector('[data-sz-opt-preview]') || root.querySelector('.sz-prod__title'));
          var galEnd = ref ? ref.getBoundingClientRect().bottom : 0;
          var on = !btnVisible && galEnd < 0 && getComputedStyle(sticky).display !== 'none';
          sticky.classList.toggle('is-on', on);
          document.documentElement.classList.toggle('sz-sticky-on', on);
        };
        scrollFns.push(syncSticky);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          var real = root.querySelector('.sz-buy [type="submit"]');
          if (real) real.click();
        });
      }
    });
  }

  /* ---- Carrito: "Añadir otra igual" para completar el pack ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-sz-upsell]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    var cart = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(b.getAttribute('data-sz-upsell'), 10), quantity: 1 }] };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { b.disabled = false; return; }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sz-upsell', cartData: res });
        if (cart && cart.renderContents) cart.renderContents(res); else window.location.reload();
      })
      .catch(function () { b.disabled = false; });
  });

  /* ---- Ventana de bienvenida: una vez por visitante ---- */
  function initPop() {
    var pop = document.querySelector('[data-sz-pop]');
    if (!pop || pop.getAttribute('data-sz-ready')) return;
    pop.setAttribute('data-sz-ready', '1');
    var KEY = 'szPopHasta';
    var state = pop.getAttribute('data-state');
    var dias = parseInt(pop.getAttribute('data-dias'), 10) || 30;
    var lastFocus = null;
    function store(ms) { try { localStorage.setItem(KEY, String(Date.now() + ms)); } catch (e) {} }
    function blocked() {
      try { return parseInt(localStorage.getItem(KEY) || '0', 10) > Date.now(); } catch (e) { return false; }
    }
    var shown = false;
    function open() {
      if (!pop.hidden || shown) return;
      // No interrumpir a quien está en el carrito: lo intenta de nuevo más tarde
      if (document.querySelector('cart-drawer.active')) { setTimeout(open, 8000); return; }
      shown = true;
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      // En el móvil no se pone el foco en el email para que no salte el teclado
      var tactil = window.matchMedia('(pointer: coarse)').matches;
      var f = (tactil && pop.querySelector('.sz-pop__x')) || pop.querySelector('input[type="email"]') || pop.querySelector('[data-sz-copy]') || pop.querySelector('.sz-pop__x');
      setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 350);
      if (state !== 'ok') store(dias * 864e5);
    }
    function close() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, reduce ? 0 : 450);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    pop.querySelectorAll('[data-sz-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    var copy = pop.querySelector('[data-sz-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = (pop.querySelector('[data-sz-code]') || {}).textContent || '';
      var done = function () { copy.textContent = copy.getAttribute('data-ok') || 'OK'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code.trim()).then(done, done); else done();
    });
    if (state === 'ok') { store(3650 * 864e5); open(); return; }
    if (state === 'error') { open(); return; }
    if (blocked()) return;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 12) * 1000;
    var boton = document.querySelector('[data-sz-prod] [data-sz-add]');
    if (boton) {
      // Ficha de producto: no interrumpir mientras decide. Sale cuando ya ha bajado más allá del precio
      // y del botón de compra, lleva al menos 30 s y no tiene nada en el carrito.
      var pasado = false, tiempo = false;
      var probar = function () {
        var cd = document.querySelector('cart-drawer');
        if (pasado && tiempo && !(cd && !cd.classList.contains('is-empty'))) open();
      };
      var mirar = function () {
        if (boton.getBoundingClientRect().bottom < 0) { pasado = true; window.removeEventListener('scroll', mirar); probar(); }
      };
      window.addEventListener('scroll', mirar, { passive: true });
      setTimeout(function () { tiempo = true; probar(); }, Math.max(delay, 30000));
    } else {
      setTimeout(open, delay);
    }
    if (isDesk()) document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }

  function init() {
    initPop();
    initReveals();
    initParallax();
    initCounters();
    initMagnetic();
    initEstilos();
    initPasos();
    initUsos();
    initDetalles();
    initFaq();
    initProducto();
    fillEntrega(document);
    watchCart();
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Editor de Shopify: re-inicializa al añadir/editar secciones
  document.addEventListener('shopify:section:load', function () { initReveals(); init(); });
})();
